import MaximizeIcon from '@mui/icons-material/Maximize';
import { useUnityBuildStore } from '../../stores/store';
import RenderTakeoffList from './RenderTakeoffList';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import { Box, IconButton, Tooltip, useTheme, alpha } from '@mui/material';
import React from 'react';
import { shallow } from 'zustand/shallow';

type AuditTrailProps = { searchTerm: string };

function AuditTrail({ searchTerm }: AuditTrailProps) {
  const theme = useTheme();

  const { showAssemblyWindow, setShowAssemblyWindow } = useStoreWithEqualityFn(
    useUnityBuildStore,
    state => ({
      showAssemblyWindow: state.showAssemblyWindow,
      setSelectedFilter: state.setSelectedFilter,
      setShowAssemblyWindow: state.setShowAssemblyWindow,
    }),
    shallow
  );

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        // Contain layout changes to prevent affecting parent elements
        contain: 'layout style',
        isolation: 'isolate',
      }}
    >
      {showAssemblyWindow ? (
        <Tooltip title="Minimize assembly window" arrow>
          <IconButton
            onClick={() => setShowAssemblyWindow(false)}
            aria-label="Minimize assembly window"
            sx={{
              color: theme.palette.primary.main,
              '&:hover': {
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
              },
            }}
          >
            <MaximizeIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <>
          <Box
            sx={{
              flexGrow: 1,
              overflowY: 'auto',
              width: '100%',
              py: 0.5,
              // Ensure this container doesn't break out of its bounds
              contain: 'strict',
              position: 'relative',
            }}
          >
            <RenderTakeoffList searchTerm={searchTerm} />
          </Box>
        </>
      )}
    </Box>
  );
}

export default React.memo(AuditTrail);
